module.exports = __webpack_public_path__ + "img/foot-top.09178296.png";